import { selectHasMatch } from 'util/selector/routerSelector';

import { createSelector } from '@reduxjs/toolkit';
import { ClientRoute } from 'app/route/client';
import { AdminState } from 'reduxStore/appStore';

import { ClientState } from './initialState';

export const selectClientDomain = (state: AdminState) => state.client as ClientState.Domain;

export const selectClientListResource = createSelector(
  selectClientDomain,
  (domain) => domain.listResource,
);

export const selectClientPagination = createSelector(
  selectClientDomain,
  (domain) => domain.listPagination,
);

export const selectHasClientMatch = selectHasMatch(ClientRoute.PROJECT_PATTERN);
